export const classes = {
  divider: 'my-2',
};
